export default "__VITE_ASSET__DD7k12NG__"